import ApplicationController from '../../javascript/controllers/application_controller'
import tippy from 'tippy.js'
import { tooltipOptions } from '../../javascript/lib/tooltip_options'

/**
 * Tooltip Controller
 *
 * Manages tooltip initialization and cleanup using tippy.js library.
 * Tooltips display helpful information when users hover over icons.
 *
 * Tracks when user views the tooltip (not when it initializes) via
 * tippy's onShown callback to capture actual user interactions.
 *
 * @extends ApplicationController
 */
export default class extends ApplicationController {
  static values = {
    content: String,
    allowHtml: Boolean,
  }

  connect() {
    tippy(
      this.element,
      tooltipOptions({
        content: this.contentValue,
        allowHTML: this.allowHtmlValue,
        onShown: (instance) => {
          this.addBreadcrumb('UI', 'tooltip_viewed', {
            content: instance.popper.textContent?.trim().substring(0, 50),
          })
        },
      }),
    )
  }

  disconnect() {
    this.element._tippy?.destroy()
  }
}
